/**
 * AppManifest
 *
 * Full application manifest — one entry per mobile app (Hub or spoke) in the
 * CCMS constellation. Mirrors the Appendix E (APP_MANIFEST_SPEC) schema and the
 * backend `CCMS.Api.ApplicationCatalogue` `AppManifest` model exactly.
 *
 * The Hub launcher, the web "Apps" page, and per-spoke "Other CCMS apps"
 * surfaces all render from this data.
 */
/**
 * Create an empty manifest pre-populated with the schema defaults. Useful as a
 * starting point for the catalogue admin "Create app" form.
 */
export function createEmptyAppManifest() {
    return {
        appId: '',
        displayName: '',
        shortName: '',
        description: '',
        iconUrl: '',
        colors: { primary: '#5B6CFF', onPrimary: '#FFFFFF' },
        platforms: {
            ios: {
                bundleId: '',
                minOSVersion: '16.0',
                storeUrl: '',
                universalLinkPaths: [],
                customScheme: '',
            },
            android: {
                applicationId: '',
                minOSVersion: '26',
                storeUrl: '',
                appLinkPaths: [],
                customScheme: '',
            },
        },
        minAppVersion: '1.0.0',
        minHubVersion: '1.0.0',
        entitlement: { anyOfRoles: [], anyOfRights: [], allOfRights: [] },
        categories: [],
        defaultDeepLink: '/',
        dashboardWidgetIds: [],
        featureFlags: {},
        webUrl: '',
        enabled: true,
        audience: 'staff',
        metadata: {},
    };
}
//# sourceMappingURL=AppManifest.js.map